import AddDevice from 'pages/AddDevice'
import DeviceReplacementDetail from 'pages/DeviceReplacementDetail'
import Devices from 'pages/Devices'
import Carriers from 'pages/Carriers'
import Manufacturers from 'pages/Manufacturers'
import Models from 'pages/Models'
import Types from 'pages/Types'
import ServiceStatuses from 'pages/ServiceStatuses'
import FailureReaons from 'pages/FailureReasons'
import AddCarrier from 'pages/AddCarrier'
import AddManufacturer from 'pages/AddManufacturer'
import AddModel from 'pages/AddModel'
import AddType from 'pages/AddType'
import AddServiceStatus from 'pages/AddServiceStatus'
import AddFailureReason from 'pages/AddFailureReason'
import Centers from 'pages/Centers'
import Sites from 'pages/Sites'
import AddCenter from 'pages/AddCenter'
import AddSite from 'pages/AddSite'
import Users from 'pages/Users'
import Superadmins from 'pages/Superadmins'
import AddUser from 'pages/AddUser'
import AddSuperadmin from 'pages/AddSuperadmin'
import Account from 'pages/Account'
import AddCustomer from 'pages/AddCustomer'
import UserPasswordChange from 'pages/UserChangePassword'
import ReportConfiguration from 'pages/ReportConfiguration'
import Page from 'shared/types/Page'
import { roles } from 'consts'
import Settings from 'pages/Settings'
import System from 'pages/System'
import DeviceTableConfig from 'pages/DeviceTableConfig'
import ImportUsers from 'pages/ImportUsers'
import ImportDevices from 'pages/ImportDevices'
import Manual from 'pages/Manual'
import AuditLog from 'pages/AuditLog'

const ReplaceDevice = () => {
  return <AddDevice isReplacement={true} />
}

const ChangePasswordSuperadmin = () => {
  return <UserPasswordChange fromSuperadminsPage={true} />
}

const ChangePasswordUser = () => {
  return <UserPasswordChange fromSuperadminsPage={false} />
}

const Pages: Page[] = [
  {
    name: 'Devices',
    component: Devices,
    path: '/',
    showInMenu: 'left',
    icon: 'tvOutline',
    addLink: '/add-device',
  },
  {
    name: 'Import Devices',
    component: ImportDevices,
    path: '/import-devices',
    parentPath: '/',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Add Device',
    component: AddDevice,
    parentPath: '/',
    path: '/add-device',
    showInMenu: false,
    roles: [roles.superAdmin, roles.admin],
  },
  {
    name: 'Edit Device',
    component: AddDevice,
    parentPath: '/',
    path: '/edit-device/:id',
    showInMenu: false,
    roles: [roles.superAdmin, roles.admin],
  },
  {
    name: 'Replace Device',
    component: ReplaceDevice,
    parentPath: '/',
    path: '/replace-device/:id',
    showInMenu: false,
    roles: [roles.superAdmin, roles.admin],
  },
  {
    name: 'View Device',
    component: AddDevice,
    parentPath: '/',
    path: '/view-device/:id',
    showInMenu: false,
    roles: [roles.user],
  },
  {
    name: 'Device Replacement Detail',
    component: DeviceReplacementDetail,
    parentPath: '/',
    path: '/device-replacement-detail/:id',
    showInMenu: false,
  },
  {
    name: 'Account',
    component: Account,
    path: '/account',
    showInMenu: 'left',
    icon: 'personCircleOutline',
    addLink: '/add-customer',
  },
  {
    name: 'Add Customer',
    component: AddCustomer,
    parentPath: '/account',
    path: '/add-customer',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Users',
    component: Users,
    path: '/users',
    parentPath: '/account',
    showInMenu: 'left',
    addLink: '/add-user',
  },
  {
    name: 'Import Users',
    component: ImportUsers,
    path: '/import-users',
    parentPath: '/users',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Change Password',
    component: ChangePasswordUser,
    path: '/change-password/:id',
    parentPath: '/users',
    showInMenu: false,
  },
  {
    name: 'Change Password',
    component: ChangePasswordSuperadmin,
    path: '/change-password-superadmin/:id',
    parentPath: '/superadmins',
    showInMenu: false,
  },
  {
    name: 'Add User',
    component: AddUser,
    path: '/add-user',
    parentPath: '/users',
    showInMenu: false,
    roles: [roles.superAdmin, roles.admin],
  },
  {
    name: 'Edit User',
    component: AddUser,
    path: '/edit-user/:id',
    parentPath: '/users',
    showInMenu: false,
  },
  {
    name: 'Add Superadmin',
    component: AddSuperadmin,
    path: '/add-superadmin',
    parentPath: '/superadmins',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Edit Superadmin',
    component: AddSuperadmin,
    path: '/edit-superadmin/:id',
    parentPath: '/superadmins',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Sites',
    component: Sites,
    path: '/sites',
    parentPath: '/account',
    showInMenu: 'left',
    addLink: '/add-site',
  },
  {
    name: 'Add Site',
    component: AddSite,
    path: '/add-site',
    parentPath: '/sites',
    showInMenu: false,
    roles: [roles.superAdmin, roles.admin],
  },
  {
    name: 'Edit Site',
    component: AddSite,
    path: '/edit-site/:id',
    parentPath: '/sites',
    showInMenu: false,
    roles: [roles.superAdmin, roles.admin],
  },
  {
    name: 'Cost Centers',
    component: Centers,
    path: '/centers',
    parentPath: '/account',
    showInMenu: 'left',
    addLink: '/add-center',
  },
  {
    name: 'Add Cost Center',
    component: AddCenter,
    path: '/add-center',
    parentPath: '/centers',
    showInMenu: false,
    roles: [roles.superAdmin, roles.admin],
  },
  {
    name: 'Edit Cost Center',
    component: AddCenter,
    path: '/edit-center/:id',
    parentPath: '/centers',
    showInMenu: false,
    roles: [roles.superAdmin, roles.admin],
  },
  {
    name: 'System',
    component: System,
    path: false,
    isDropdown: true,
    showInMenu: 'left',
    icon: 'settingsOutline',
  },
  {
    name: 'Settings',
    component: Settings,
    path: '/settings',
    parentPath: '#System',
    dropdownName: 'System',
    showInMenu: 'left',
  },
  {
    name: 'Variables',
    component: System,
    path: '/variables',
    parentPath: '#System',
    dropdownName: 'System',
    showInMenu: 'left',
    roles: [roles.superAdmin],
  },
  {
    name: 'Report Configuration',
    component: ReportConfiguration,
    path: '/report-configuration',
    parentPath: '#System',
    dropdownName: 'System',
    showInMenu: 'left',
    roles: [roles.superAdmin],
  },
  {
    name: 'Device Table Config',
    component: DeviceTableConfig,
    path: '/device-table-config',
    parentPath: '#System',
    dropdownName: 'System',
    showInMenu: 'left',
    roles: [roles.superAdmin],
  },
  {
    name: 'Superadmins',
    component: Superadmins,
    path: '/superadmins',
    parentPath: '#System',
    dropdownName: 'System',
    showInMenu: 'left',
    addLink: '/add-superadmin',
    roles: [roles.superAdmin],
  },
  {
    name: 'Audit Log',
    component: AuditLog,
    path: '/audit-log',
    parentPath: '#System',
    dropdownName: 'System',
    showInMenu: 'left',
    roles: [roles.superAdmin],
  },
  {
    name: 'Manual',
    component: Manual,
    path: '/manual',
    parentPath: '#System',
    dropdownName: 'System',
    showInMenu: 'left',
  },
  {
    name: 'Carriers',
    component: Carriers,
    path: '/carriers',
    parentPath: '#System',
    dropdownName: 'System',
    showInMenu: false,
    addLink: '/add-carrier',
    roles: [roles.superAdmin],
  },
  {
    name: 'Add Carrier',
    component: AddCarrier,
    parentPath: '/carriers',
    path: '/add-carrier',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Edit Carrier',
    component: AddCarrier,
    parentPath: '/carriers',
    path: '/edit-carrier/:id',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Device Manufacturers',
    component: Manufacturers,
    path: '/manufacturers',
    parentPath: '#System',
    dropdownName: 'System',
    showInMenu: false,
    addLink: '/add-manufacturer',
    roles: [roles.superAdmin],
  },
  {
    name: 'Add Device Manufacturer',
    component: AddManufacturer,
    parentPath: '/manufacturers',
    path: '/add-manufacturer',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Edit Device Manufacturer',
    component: AddManufacturer,
    parentPath: '/manufacturers',
    path: '/edit-manufacturer/:id',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Device Models',
    component: Models,
    path: '/models',
    parentPath: '#System',
    dropdownName: 'System',
    showInMenu: false,
    addLink: '/add-model',
    roles: [roles.superAdmin],
  },
  {
    name: 'Add Device Model',
    component: AddModel,
    parentPath: '/models',
    path: '/add-model',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Edit Device Model',
    component: AddModel,
    parentPath: '/models',
    path: '/edit-model/:id',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Device Types',
    component: Types,
    path: '/types',
    parentPath: '#System',
    dropdownName: 'System',
    showInMenu: false,
    addLink: '/add-type',
    roles: [roles.superAdmin],
  },
  {
    name: 'Add Device Type',
    component: AddType,
    parentPath: '/types',
    path: '/add-type',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Edit Device Type',
    component: AddType,
    parentPath: '/types',
    path: '/edit-type/:id',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Service Statuses',
    component: ServiceStatuses,
    path: '/service-statuses',
    parentPath: '#System',
    dropdownName: 'System',
    showInMenu: false,
    addLink: '/add-service-status',
    roles: [roles.superAdmin],
  },
  {
    name: 'Add Service Status',
    component: AddServiceStatus,
    parentPath: '/service-statuses',
    path: '/add-service-status',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Edit Service Status',
    component: AddServiceStatus,
    parentPath: '/service-statuses',
    path: '/edit-service-status/:id',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Failure Reasons',
    component: FailureReaons,
    path: '/failure-reasons',
    parentPath: '#System',
    dropdownName: 'System',
    showInMenu: false,
    addLink: '/add-failure-reason',
    roles: [roles.superAdmin],
  },
  {
    name: 'Add Failure Reason',
    component: AddFailureReason,
    parentPath: '/failure-reasons',
    path: '/add-failure-reason',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
  {
    name: 'Edit Failure Reason',
    component: AddFailureReason,
    parentPath: '/failure-reasons',
    path: '/edit-failure-reason/:id',
    showInMenu: false,
    roles: [roles.superAdmin],
  },
]

export default Pages
